import { getCdnUrl } from './urls'

export interface Protocol {
  name: string
  imageSrc: string
  supportSignature: boolean
}

const aaveLogoSrc = getCdnUrl('/assets/logos/aave.svg')
const compoundLogoSrc = getCdnUrl('/assets/logos/comp.svg')
const moonwellLogoSrc = getCdnUrl('/assets/logos/well.svg')

export const COMMON_PROTOCOLS = {
  aaveV3Optimizer: {
    name: 'Morpho Aave V3',
    imageSrc: aaveLogoSrc,
    supportSignature: true
  },
  aaveV2: {
    name: 'Aave V2',
    imageSrc: aaveLogoSrc,
    supportSignature: true
  },
  aaveV3: {
    name: 'Aave V3',
    imageSrc: aaveLogoSrc,
    supportSignature: true
  },
  compoundV2: {
    name: 'Compound v2',
    imageSrc: compoundLogoSrc,
    supportSignature: false
  },
  compoundV3: {
    name: 'Compound III',
    imageSrc: compoundLogoSrc,
    supportSignature: true
  },
  moonwell: {
    name: 'Moonwell',
    imageSrc: moonwellLogoSrc,
    supportSignature: false
  }
} as const

export type ProtocolName = Exclude<keyof typeof COMMON_PROTOCOLS, 'moonwell'>
